import {
  JOBSEEKER_LOGIN_REQUEST,
  JOBSEEKER_LOGIN_SUCCESS,
  JOBSEEKER_LOGIN_FAILURE,
  RESET_JOB,
} from "../../actionTypes";

const initialState = {
  status: false,
  isLoading: false,
  message: "",
  data: {},
};

const jobseekerLoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case JOBSEEKER_LOGIN_REQUEST:
      // console.log(action.payload);
      return {
        ...state,
        isLoading: true,
      };
    case JOBSEEKER_LOGIN_SUCCESS:
      return {
        ...state,
        status: action.payload.status,
        isLoading: false,
        message: action.payload.message,
        data: action.payload.data,
      };
    case JOBSEEKER_LOGIN_FAILURE:
      return {
        ...state,
        status: action.payload.status,
        isLoading: false,
        message: action.payload.message,
      };

    case RESET_JOB: // Reset job data
      return {
        ...state,
        status: false,
        isLoading: false,
        message: "",
      };
    default:
      return state;
  }
};

export default jobseekerLoginReducer;
